import React from 'react';

const style = {
  display: 'inline-block',
  userSelect: 'none',
  flexShrink: 0,
};

const ReloadIcon = ({ color = 'black', style: overrideStyles = {}, ...attr }) => {
  return (
    <svg style={{ ...style, ...overrideStyles }} width="12" height="10" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg" {...attr}>
      <path d="M1 6.00195L3.05798 8.1171L5.17312 6.00195" stroke={color} style={{ strokeMiterlimit: 10 }} />
      <path d="M3 5L3 8" stroke={color} style={{ strokeMiterlimit: 10 }} />
      <path d="M7 9C9.20914 9 11 7.20914 11 5C11 2.79086 9.20914 1 7 1C4.79086 1 3 2.79086 3 5" stroke={color} />
    </svg>
  );
};

export default ReloadIcon;
